const initialMessageState = {
  message : false,
  type: '',
  isVisible:false
}

export const MessageReducer = (state = initialMessageState, action = {}) => {
 
    switch (action.type) {            
        case 'MESSAGE':
            return {
              ...state,
              message: action.messageData.message,
              type: action.messageData.type,
              isVisible: true              
            }
        case 'USER_LOGOUT':
          return initialMessageState;
        case 'ISVISIBLE':      
          return {
              ...state,
              isVisible: action.visible
          }    
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/reducers/MessageReducer.js